import { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import api from "../../../service/api";
import BatchClassDetails from "./components/BatchClassDetails";
import DynamicTable from "../../../components/version-two-components/DynamicTable";
import { columns } from "./components/columns";
import TrainingDates from "./components/TrainingDates";

const ClassAbsentees = () => {
    const { id } = useParams();
    const [batchDetails, setBatchDetails] = useState({
        batch_students: [],
    });

    const [defaultAccordion, setDefaultAccordion] = useState();
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSession, setSelectedSession] = useState(null);

    const fetchBatchDetails = useCallback(
        async (session = null, date = null, accordionMenu = null) => {
            let url = `tms/batches/bca-attendance/list/${id}`;

            const params = new URLSearchParams();

            if (date) params.append("date", date);
            if (session) params.append("session", session);

            if (params.toString()) {
                url += `?${params.toString()}`;
            }

            const response = await api.get(url);

            setBatchDetails(response?.data?.batch);
            setDefaultAccordion(accordionMenu);

            setSelectedDate(date);
            setSelectedSession(session);
        },
        [id]
    );

    useEffect(() => {
        fetchBatchDetails();
    }, [fetchBatchDetails]);

    return (
        <>
            <Helmet title="Class Absentees" />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Class - Absent Students</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <BatchClassDetails batchData={batchDetails ?? []} />
                        <TrainingDates
                            batch={batchDetails}
                            type="attendance"
                            batchStudents={fetchBatchDetails}
                            defaultAccordion={defaultAccordion}
                        />
                    </Col>
                    <Col md={8} fluid>
                        <Row className="mb-2">
                            <Col>
                                <div className="p-2 bg-light rounded">
                                    {selectedDate && selectedSession ? (
                                        <>
                                            <strong>Date:</strong>{" "}
                                            {selectedDate} &nbsp; | &nbsp;
                                            <strong>Session:</strong>{" "}
                                            {selectedSession.toUpperCase()}
                                        </>
                                    ) : (
                                        "Showing all training dates"
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <DynamicTable
                            className={"w-100"}
                            dataPagination={{
                                data: batchDetails.batch_students,
                                meta: "",
                                links: "",
                            }}
                            isPaginated={false}
                            isFullPage={false}
                            columns={columns}
                            api={fetchBatchDetails}
                        />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ClassAbsentees;
